import React, { useState } from "react";
import {
  server_post_data,
  repairing_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import {
  handleError,
  handleNumbersChange,
} from "../../CommonJquery/CommonJquery";
import { X } from "lucide-react";

const RepairStep1 = ({
  onNext,
  onBack,
  cardata,
  MaintainanceData,
  ImageLink,
  setCount,
    BookingData,
  FromComeData,
}) => {
  console.log(MaintainanceData);
  const cornerImages = MaintainanceData?.corner_image?.split("@@@");
  const [safetyData, setSafetyData] = useState({
    odometerReading: MaintainanceData.odo_metter,
    corner_image1_file: "",
    corner_image1: "0",
    corner_image2_file: "",
    corner_image2: "0",
    corner_image3_file: "",
    corner_image3: "0",
    corner_image4_file: "",
    corner_image4: "0",
    odo_image_file: "",
    odo_image: MaintainanceData?.odo_image ?? "0",
    odo_image_old:
      (MaintainanceData?.odo_image ?? "").trim() === ""
        ? "0"
        : MaintainanceData.odo_image,
  });

  console.log(cornerImages);
  const [carImages, setCarImages] = useState({
    frontLeft: cornerImages?.[0] || "0",
  frontRight: cornerImages?.[1] || "0",
  backLeft: cornerImages?.[2] || "0",
  backRight: cornerImages?.[3] || "0",
  });

 const [carImagesOld] = useState({
  frontLeft: cornerImages?.[0] || "0",
  frontRight: cornerImages?.[1] || "0",
  backLeft: cornerImages?.[2] || "0",
  backRight: cornerImages?.[3] || "0",
});
  const [errors, setErrors] = useState({
    odometerReading: "",
    dashboardImg: "",
    frontLeft: "",
    frontRight: "",
    backLeft: "",
    backRight: "",
  });

  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  const handleDashboardImgUpload = (e, flag) => {
    const file = e.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      uploadImageserver(file, flag);
    } else {
      setErrors((prev) => ({
        ...prev,
        odo_image: "Please upload a valid image (PNG, JPG, JPEG)",
      }));
    }
  };

  const handleRemoveDashboardImg = () => {
    setSafetyData({ ...safetyData, odo_image_file: "", odo_image: "" });
    setErrors((prev) => ({ ...prev, odo_image: "" }));
  };

  const handleImageChange = (e, position) => {
    const file = e.target.files[0];
    if (file) {
      setCarImages((prev) => ({ ...prev, [position]: file }));
      setErrors((prev) => ({ ...prev, [position]: "" }));
    }
  };

  const removeImage = (position) => {
    setCarImages((prev) => ({ ...prev, [position]: null }));
    setErrors((prev) => ({ ...prev, [position]: "This field is required" }));
  };

  const renderImageInput = (label, position, id, flag) => (
    <div className="col-md-6 col-lg-3 mb-3">
      <label htmlFor={id} className="form-label">
        {label} <span className="mandory_field">*</span>
      </label>
      {errors[position] && (
        <span className="error-text d-block">{errors[position]}</span>
      )}
      {!carImages[position] || carImages[position] === "0" ? (
        <input
          id={id}
          type="file"
          accept="image/*"
          // onChange={(e) => }
          onChange={(e) => {
            handleImageChange(e, position);
            handleDashboardImgUpload(e, flag);
          }}
          className="form-control file-input"
        />
      ) : (
        <div className="image-preview position-relative">
          <img
            src={
              typeof carImages[position] === "string"
                ? ImageLink + carImages[position] // for backend image strings
                : URL.createObjectURL(carImages[position]) // for uploaded files
            }
            alt={label}
            style={{ height: "100px", width: "100px", borderRadius: "6px" }}
          />
          <X
            className="removeBttn position-absolute top-0 end-0 m-1 cursor-pointer"
            size={18}
            onClick={() => removeImage(position)}
          />
        </div>
      )}
    </div>
  );

  const validateFields = () => {
    const newErrors = {};
    let hasError = false;

    if (!safetyData.odometerReading.trim()) {
      newErrors.odometerReading = "Please enter Odometer Reading";
      hasError = true;
    }

    if (!safetyData.odo_image) {
      newErrors.odo_image = "Please upload a picture of the odometer";
      hasError = true;
    }

    ["frontLeft", "frontRight", "backLeft", "backRight"].forEach((key) => {
      if (!carImages[key] || carImages[key] === "0") {
        newErrors[key] = "This field is required";
        hasError = true;
      }
    });

    setErrors(newErrors);
    return !hasError;
  };

  const handleNext = async () => {
    if (!validateFields()) return;

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", cardata.primary_id);
    fd.append("odo_metter", safetyData.odometerReading);
    fd.append("odo_image", safetyData.odo_image);
    fd.append("odo_image_old", safetyData.odo_image_old);
    fd.append("corner_image1", safetyData.corner_image1);
    fd.append("corner_image2", safetyData.corner_image2);
    fd.append("corner_image3", safetyData.corner_image3);
    fd.append("corner_image4", safetyData.corner_image4);
    fd.append("corner_image1_old", carImagesOld.frontLeft);
    fd.append("corner_image2_old", carImagesOld.frontRight);
    fd.append("corner_image3_old", carImagesOld.backLeft);
    fd.append("corner_image4_old", carImagesOld.backRight);
    fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
    fd.append("step_for_repairing", 1);
    fd.append("save_or_edit_type", FromComeData);

    Object.entries(carImages).forEach(([key, file]) => {
      fd.append(key, file);
    });

    await server_post_data(repairing_car_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          onNext();
          setCount(2);
        }
        setshowLoaderAdmin(false);
      })
      .catch((e) => {
        console.log(e);
        handleError("Network error");
        setshowLoaderAdmin(false);
      });
  };

  const uploadImageserver = async (file, flag) => {
    const fd = new FormData();
    fd.append("image", file);
    await server_post_data(upload_image_to_folder, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (flag == 1) {
            setSafetyData((prevState) => ({
              ...prevState,
              corner_image1_file: file,
              corner_image1: Response.data.message.image_uploaded,
            }));
          }
          if (flag == 2) {
            setSafetyData((prevState) => ({
              ...prevState,
              corner_image2_file: file,
              corner_image2: Response.data.message.image_uploaded,
            }));
          }
          if (flag == 3) {
            setSafetyData((prevState) => ({
              ...prevState,
              corner_image3_file: file,
              corner_image3: Response.data.message.image_uploaded,
            }));
          }
          if (flag == 4) {
            setSafetyData((prevState) => ({
              ...prevState,
              corner_image4_file: file,
              corner_image4: Response.data.message.image_uploaded,
            }));
          }
          if (flag == 0) {
            setSafetyData((prevState) => ({
              ...prevState,
              odo_image_file: file,
              odo_image: Response.data.message.image_uploaded,
            }));
          }
        }
      })
      .catch((error) => { });
  };

  return (
    <>
      <div className="safety-checks-container1">
        <h3 className="section-title text-primary">
          Odometer & Vehicle Images <span className="mandory_field">*</span>
        </h3>

        <div className="row align-items-start">
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Odometer Reading: <span className="mandory_field">*</span>
            </label>
            {errors.odometerReading && (
              <span className="error-text d-backRightImageInputblock">
                {errors.odometerReading}
              </span>
            )}
            <input
              className="form-control"
              type="text"
              value={safetyData.odometerReading}
              maxLength={6}
              onChange={(e) =>
                setSafetyData((prev) => ({
                  ...prev,
                  odometerReading: e.target.value,
                }))
              }
              onInput={handleNumbersChange}
              placeholder="Enter Odometer Reading"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Picture of Odometer: <span className="mandory_field">*</span>
            </label>
            {errors.odo_image && (
              <span className="error-text d-block">{errors.odo_image}</span>
            )}
            {(safetyData.odo_image == "" || safetyData.odo_image == "0") && (
              <input
                id="dashboardImgInput"
                className="form-control mb-2"
                type="file"
                onChange={(e) => handleDashboardImgUpload(e, 0)}
                accept=".png, .jpeg, .jpg"
              />
            )}
            {safetyData.odo_image && safetyData.odo_image !="0" && (
              <div className="oil_close_cap_div position-relative">
                <img
                  src={ImageLink + safetyData.odo_image}
                  alt="Uploaded Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                />
                <X
                  className="removeBttn position-absolute top-0 end-0 m-1 cursor-pointer"
                  size={18}
                  onClick={handleRemoveDashboardImg}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="repo-form-car-images">
            <div className="row">
              {renderImageInput(
                "Front Left",
                "frontLeft",
                "frontLeftImageInput",
                "1"
              )}
              {renderImageInput(
                "Front Right",
                "frontRight",
                "frontRightImageInput",
                "2"
              )}
              {renderImageInput(
                "Back Left",
                "backLeft",
                "backLeftImageInput",
                "3"
              )}
              {renderImageInput(
                "Back Right",
                "backRight",
                "backRightImageInput",
                "4"
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default RepairStep1;
